export const SPORTS_WITHOUT_PALAY = ["basketball", "volleyball"];
export const SPORTS_WITHOUT_COMBO = ["volleyball"];
export const MAX_PAYOUT = 1000000; // 1M
export const CR_SCORE: Record<string, string> = {
  274: "0:0",
  276: "1:0",
  278: "2:0",
  280: "3:0",
  282: "4:0",
  284: "0:1",
  286: "1:1",
  288: "2:1",
  290: "3:1",
  292: "4:1",
  294: "0:2",
  296: "1:2",
  298: "2:2",
  300: "3:2",
  302: "4:2",
  304: "0:3",
  306: "1:3",
  308: "2:3",
  310: "3:3",
  312: "4:3",
  314: "0:4",
  316: "1:4",
  318: "2:4",
  320: "3:4",
  322: "4:4",
  324: "AOS",
};

export const HT_FT: Record<string, string> = {
  418: "HH",
  420: "HD",
  422: "HA",
  424: "DH",
  426: "DD",
  428: "DA",
  430: "AH",
  432: "AD",
  434: "AA",
};

export const HT_FT_OE: Record<string, string> = {
  11: "Odd/Odd",
  12: "Odd/Even",
  21: "Even/Odd",
  22: "Even/Even",
};

export const TTG: Record<string, string> = {
  41: "0-1",
  42: "2-3",
  43: "4-6",
  44: "7+",
};
